import { useAuth } from 'grabbitbot-legacy-ui'

/** Equivalent of legacy `UserComponent` — a minimal profile view. Legacy had
 * no editable-profile UI beyond viewing `GET /user/current` (no
 * `/user/*` update endpoint exists in the contract), so this stays read-only. */
export function UserPage() {
  const { user } = useAuth()
  if (!user) return null

  return (
    <div className="screener-card screener-card--profile">
      <h1>Your account</h1>
      <dl>
        <dt>Email</dt>
        <dd>{user.username}</dd>
        {user.roles && user.roles.length > 0 && (
          <>
            <dt>Roles</dt>
            <dd>{user.roles.join(', ')}</dd>
          </>
        )}
      </dl>
    </div>
  )
}
